import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import IconButton from 'components/common/IconButton';
import Menu, { MenuItem } from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';
import IconMoreVert from 'components/icons/IconMoreVert';
import WorkflowStatusCreateEditDialog from 'components/settings/WorkflowStatusCreateEditDialog';
import Link from 'components/common/Link';
import IconArrowLeft from 'components/icons/IconArrowLeft';
import IconCheck from 'components/icons/IconCheck';

import splitLongWords from 'utils/splitLongWords';

import { deleteWorkflowStatus } from 'redux/modules/workflowStatuses';

const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
    flexWrap: 'nowrap',
    '&:last-child td': {
      borderBottom: 'none',
    },
    '&:hover $buttonMenu button': {
      opacity: 1,
    },
  },
  iconMoreVert: {
    width: 24,
    height: 24,
  },
  buttonCell: {
    textAlign: 'right',
    padding: 0,
    '&:last-child': {
      padding: 0,
    },
  },
  cellName: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '70%',
    flexBasis: '70%',
    paddingRight: 0,
    paddingTop: 8,
    paddingBottom: 8,
  },
  buttonMenu: {
    '& button': {
      opacity: 0,
      transition: theme.transitions.create(['opacity'], {
        duration: theme.transitions.duration.short,
      }),
      '&:focus': {
        opacity: 1,
      },
    },
  },
  buttonMenuActive: {
    '& button': {
      opacity: 1,
    },
  },
  iconArrowLeft: {
    width: 10,
    height: 10,
    margin: '-2px 0 0 10px',
    verticalAlign: 'middle',
    transform: 'rotate(180deg)',
    color: 'inherit',
  },
  state: {
    display: 'inline-block',
    margin: '-2px 0 0 10px',
    width: 12,
    height: 12,
    fontSize: 10,
    lineHeight: '14px',
    padding: 0,
    textAlign: 'center',
    verticalAlign: 'middle',
    color: theme.palette.common.white,
    borderRadius: '50%',
  },
  stateIntake: {
    backgroundColor: theme.palette.states.intake,
  },
  stateDelivery: {
    backgroundColor: theme.palette.states.delivery,
  },
  stateBilling: {
    backgroundColor: theme.palette.states.billing,
  },
  stateCollection: {
    backgroundColor: theme.palette.states.collection,
  },
  statePaid: {
    backgroundColor: theme.palette.states.paid,
  },
  iconCheck: {
    width: 12,
    height: 12,
    marginRight: 4,
  },
});

class WorkflowStatusesTableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      deleteMenuOpen: false,
      editDialogOpen: false,
    };

    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onDeleteMenuItemClick = this.onDeleteMenuItemClick.bind(this);
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
    this.onEditMenuItemClick = this.onEditMenuItemClick.bind(this);
    this.onEditDialogClose = this.onEditDialogClose.bind(this);
  }

  onMenuButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
      deleteMenuOpen: false,
    });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onEditMenuItemClick() {
    this.setState({
      anchorEl: null,
      editDialogOpen: true,
    });
  }

  onDeleteMenuItemClick() {
    this.setState({ deleteMenuOpen: true });
  }

  onDeleteCancel() {
    this.setState({ anchorEl: null });
  }

  onDeleteSubmit() {
    const { ID, Name, actions, onWorkflowStatusDeleteFail } = this.props;
    actions.deleteWorkflowStatus({
      values: { ID },
      showNotification: false,
      reject: (error) => {
        onWorkflowStatusDeleteFail({
          error: error.description,
          reassignWorkflowStatus: {
            ID,
            Name,
          },
        })
      },
    });
    this.setState({
      deleteMenuOpen: false,
      anchorEl: null,
    });
  }

  onEditDialogClose() {
    this.setState({ editDialogOpen: false });
  }

  render() {
    const { ID, account, Name, Description, classes } = this.props;
    const { anchorEl, deleteMenuOpen, editDialogOpen } = this.state;
    const open = Boolean(anchorEl);

    return (
      <TableRow className={classes.root}>
        <TableCell className={classes.cellName}>
          <Link
            breakWord
            {...this.props['Is Default'] ? {
              color: 'secondary',
            } : {}}
            onClick={this.onEditMenuItemClick}
          >
            {this.props['Is Default'] &&
              <IconCheck className={classes.iconCheck} />
            }
            {splitLongWords(Name)}
            {((this.props['Next Workflow Status'] && this.props['Next Workflow Status'].ID)) && (
              <Fragment>
                <IconArrowLeft className={classes.iconArrowLeft} />
                {(this.props['Next Workflow Status']['Workflow State'] && this.props['Next Workflow Status']['Workflow State'].ID === 1) && (
                  <span className={classNames(classes.state, classes.stateIntake)}>
                    I
                  </span>
                )}
                {(this.props['Next Workflow Status']['Workflow State'] && this.props['Next Workflow Status']['Workflow State'].ID === 2) && (
                  <span className={classNames(classes.state, classes.stateDelivery)}>
                    D
                  </span>
                )}
                {(this.props['Next Workflow Status']['Workflow State'] && this.props['Next Workflow Status']['Workflow State'].ID === 3) && (
                  <span className={classNames(classes.state, classes.stateBilling)}>
                    B
                  </span>
                )}
                {(this.props['Next Workflow Status']['Workflow State'] && this.props['Next Workflow Status']['Workflow State'].ID === 4) && (
                  <span className={classNames(classes.state, classes.stateCollection)}>
                    C
                  </span>
                )}
                {(this.props['Next Workflow Status']['Workflow State'] && this.props['Next Workflow Status']['Workflow State'].ID === 5) && (
                  <span className={classNames(classes.state, classes.statePaid)}>
                    P
                  </span>
                )}
              </Fragment>
            )}
          </Link>
        </TableCell>
        <TableCell className={classes.buttonCell}>
          <IconButton
            className={classNames(classes.buttonMenu, {
              [classes.buttonMenuActive]: open,
            })}
            aria-label="More"
            aria-owns={open ? `${ID}-workflow-status-menu` : null}
            aria-haspopup="true"
            onClick={this.onMenuButtonClick}
            tooltipContent="Open Menu"
          >
            <IconMoreVert className={classes.iconMoreVert} />
          </IconButton>
          <Menu
            id={`${ID}-workflow-status-menu`}
            anchorEl={anchorEl}
            open={open}
            onClose={this.onMenuClose}
            list={!deleteMenuOpen}
            maxHeight={130}
          >
            {deleteMenuOpen ? (
              <DeleteMenu
                text="Are you sure you want to delete this workflow status?"
                onCancel={this.onDeleteCancel}
                onSubmit={this.onDeleteSubmit}
              />
            ) : (
              <Fragment>
                <MenuItem onClick={this.onEditMenuItemClick}>
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={this.onDeleteMenuItemClick}
                  color="warning"
                  disabled={account.Roles.filter(item =>
                    item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
                >
                  Delete
                </MenuItem>
              </Fragment>
            )}
          </Menu>
        </TableCell>
        <WorkflowStatusCreateEditDialog
          form={`workflowStatusEdit-${ID}`}
          open={editDialogOpen}
          ID={ID}
          initialValues={{
            Name,
            Description,
            'Workflow State ID': this.props['Workflow State'].ID,
            'Workflow State Name': this.props['Workflow State'].Name,
            'Selected Workflow State Name': this.props['Workflow State'].Name,
            'Is Default': this.props['Is Default'],
            'Is History': this.props['Is History'],
            'Next Workflow Status ID': this.props['Next Workflow Status'].ID,
            'Next Workflow Status Name': this.props['Next Workflow Status'].Name,
            'Selected Next Workflow Status Name': this.props['Next Workflow Status'].Name,
            'Is Delivered': this.props['Is Delivered'],
          }}
          onClose={this.onEditDialogClose}
          onSubmitSuccess={this.onEditDialogClose}
        />
      </TableRow>
    );
  }
}

WorkflowStatusesTableRow.propTypes = {
  ID: PropTypes.number.isRequired,
  Name: PropTypes.string.isRequired,
  Description: PropTypes.string,
  'Is Default': PropTypes.bool,
  'Is History': PropTypes.bool,
  actions: PropTypes.shape({
    deleteWorkflowStatus: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  'Workflow State': PropTypes.shape({
    ID: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
  }).isRequired,
  'Next Workflow Status': PropTypes.shape({
    ID: PropTypes.number,
    Name: PropTypes.string,
    'Workflow State': PropTypes.shape({
      ID: PropTypes.number,
      Name: PropTypes.string,
    }),
  }),
  classes: PropTypes.shape({
    iconMoreVert: PropTypes.string.isRequired,
    buttonCell: PropTypes.string.isRequired,
  }).isRequired,
};

WorkflowStatusesTableRow.defaultProps = {
  'Is Default': false,
  'Is History': false,
  'Next Workflow Status': null,
  Description: null,
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ deleteWorkflowStatus }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(WorkflowStatusesTableRow),
);



// WEBPACK FOOTER //
// ./src/components/settings/WorkflowStatusesTable/WorkflowStatusesTableRow.js